import { useSearch } from "@tanstack/react-router";
import { AdminDashboardHeader } from "./AdminDashboardHeader";

import {
  adminPanelConfig,
  adminPanelRegistry,
  AdminFallbackPanel,
  type AdminPanelRenderer,
} from "../panels";
import type { AdminSearchParams } from "../types";

export function AdminDashboard() {
  const { panel } = useSearch({
    from: "/admin",
  }) as AdminSearchParams;

  const PanelComponent: AdminPanelRenderer =
    adminPanelRegistry[panel] ?? AdminFallbackPanel;

  const panelTitle = adminPanelConfig[panel]?.title ?? "Admin";

  return (
    <section className="space-y-8 pt-6 pl-4">
      <AdminDashboardHeader panelTitle={panelTitle} />
      <div className="w-full">
        <PanelComponent />
      </div>
    </section>
  );
}
